export default "__VITE_ASSET__C9$CXNG0__"